import React from "react";

function Space({ x, y }) {
  return <div style={{ marginLeft: x || 0, marginTop: y || 0 }} />;
}
export default Space;
